import React, { useContext, useState } from 'react';
import { AuthContext } from '../../auth/AuthContext';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import { Button, Card, Col, Form, Modal, Row, Spinner, Alert } from 'react-bootstrap';
import { UserContext } from '../../context/user/ContextUser';

const ModChangeAgentePay = ({ show, onClose, data, callBk }) => {
    const { setResp } = useContextInfo();
    const { usersState } = useContext(UserContext);

    const [agenteId, setAgenteId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const agenteSeleccionado = usersState.agentes.find((a) => a.id_agent === Number(agenteId));

    const onSubmit = async () => {
        if (!agenteId) {
            setError('Selecciona un agente válido');
            return;
        }

        setError('');
        setLoading(true);

        const body = {
            ...data,
            idagente: agenteSeleccionado.id_agent,
            agente: agenteSeleccionado.name,
            campo: agenteSeleccionado.campo,
        };

        const res = await fetchConToken(
            `factura/coretetransfer`, 
            body,
            'PUT'
        );

        setResp(res);
        setLoading(false);
        callBk();

        if (res.ok) {
            onClose();
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Transferir pago a nuevo agente</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <div className="mb-3">
                                    <strong>Factura:</strong>
                                    {data?.idf}
                                    <br />
                                    <strong>Monto:</strong> ${data?.monto}
                                    <br />
                                    <strong>Cliente:</strong> {data?.nombre}
                                </div>

                                {error && <Alert variant="danger">{error}</Alert>}

                                <Form.Group className="mb-3">
                                    <Form.Label>Agente</Form.Label>
                                    <Form.Select
                                        value={agenteId}
                                        required
                                        onChange={(e) => setAgenteId(e.target.value)}>
                                        <option value="">-- SELECCIONAR AGENTE --</option>
                                        {usersState.agentes
                                            .filter((a) => a.status === true)
                                            .map((a) => (
                                                <option key={a.id_agent} value={a.id_agent}>
                                                    {a.name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>

                                <div className="d-flex justify-content-end">
                                    <Button variant="secondary" className="me-2" onClick={onClose} disabled={loading}>
                                        Cancelar
                                    </Button>

                                    <Button variant="primary" onClick={onSubmit} disabled={loading}>
                                        {loading ? (
                                            <>
                                                <Spinner as="span" animation="border" size="sm" className="me-2" />
                                                Transfiriendo...
                                            </>
                                        ) : (
                                            'Transferir pago'
                                        )}
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default ModChangeAgentePay;
